import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-cobalt/5 px-5 py-10" data-id="element-158" data-mp="3fyhq1vsbkxc4">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-159" data-mp="2eta7e7at68hv">
        <p className="text-sm font-medium text-ink sm:text-base" data-id="element-160" data-mp="29u5yzivpkesl">
          <span className="text-cobalt" data-id="element-161" data-mp="29scv2bchc8oa">504 pagine</span> di materiali interamente in italiano ·
          Pronti da stampare · Pensati per la scuola secondaria di secondo grado
        </p>
      </div>
    </section>;
}